import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  height: 100%;
  min-height: 60%;
  padding: 24px 0px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.white};
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: -0.2px;
`;

export const QuizInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const QuizTypeText = styled.p`
  color: ${({ theme }) => theme.colors.black8};
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const DescriptionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  max-width: 60%;
  text-align: center;

  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;
